import type { dashboardCanvasRendererProps } from '@/components/dashboard/DashboardCanvas';
import { DashboardMetricCard } from '../../../dashboard/components/DashboardMetricCard';
import { formatDashboardPreviousPeriod } from '../../../dashboard/format';
import { dashboardTimeline } from '../../../dashboard/model';
import type { PublisherDashboardRuntime } from '../widgetRuntime';
import { PublisherDashboardWidgetType, type PublisherDashboardWidget } from '../widgetModel';

export function PublisherMetricRenderer({
  widget,
  runtime,
}: dashboardCanvasRendererProps<PublisherDashboardWidget, PublisherDashboardRuntime>) {
  if (widget.type !== PublisherDashboardWidgetType.Metric) return null;
  return (
    <DashboardMetricCard
      metric={widget.metric}
      total={runtime.overview.data?.total}
      previous={runtime.overview.data?.totalPrevious}
      comparisonPeriod={formatDashboardPreviousPeriod(
        runtime.range,
        runtime.overview.data?.previousPeriodEnd,
      )}
      timeline={
        runtime.overview.data ? dashboardTimeline(runtime.overview.data, runtime.range) : []
      }
      loading={runtime.overview.isLoading}
      error={runtime.overview.isError}
      actions={[]}
    />
  );
}
